import { deleteReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { ActivityReport, activityReportFromJson, ActivityReportPaginationFilterRequest } from '@/models/activity-report.model';
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";

export const getPagedActivityReports = async (input: ActivityReportPaginationFilterRequest): Promise<PagedResponseModel<ActivityReport>> => {
  return await getReq(createUrl("a/Activity/Report/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => activityReportFromJson(itm))
  }));
};

export const getActivityReport = async (id: number): Promise<BaseResponseModel<ActivityReport>> => {
  return await getReq(createUrl(`a/Activity/Report/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: activityReportFromJson(res.data.result)
  }));
};

export const deleteActivityReport = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/Activity/Report/Delete/${id}`),
  ).then((res: any) => res.data);
};
